// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LogoutRouteImport } from './routes/logout'
import { Route as LoginRouteImport } from './routes/login'
import { Route as Keys4steamPreviewRouteImport } from './routes/keys4steam-preview'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as SiteRouteImport } from './routes/_site'
import { Route as AdminIndexRouteImport } from './routes/admin.index'
import { Route as AdminShopsRouteImport } from './routes/admin.shops'
import { Route as AdminOffersRouteImport } from './routes/admin.offers'
import { Route as AdminLoginRouteImport } from './routes/admin.login'
import { Route as AdminImportRouteImport } from './routes/admin.import'
import { Route as AdminGiftCardsRouteImport } from './routes/admin.gift-cards'
import { Route as AdminGamivoRouteImport } from './routes/admin.gamivo'
import { Route as AdminGamingDragonsRouteImport } from './routes/admin.gaming-dragons'
import { Route as AdminGamesplanetRouteImport } from './routes/admin.gamesplanet'
import { Route as AdminGamesRouteImport } from './routes/admin.games'
import { Route as AdminGamersgateRouteImport } from './routes/admin.gamersgate'
import { Route as AdminGameboostRouteImport } from './routes/admin.gameboost'
import { Route as AdminGamebilletRouteImport } from './routes/admin.gamebillet'
import { Route as AdminEnebaRouteImport } from './routes/admin.eneba'
import { Route as AdminElectronicFirstRouteImport } from './routes/admin.electronic-first'
import { Route as AdminCjsCdkeysRouteImport } from './routes/admin.cjs-cdkeys'
import { Route as SiteIndexRouteImport } from './routes/_site.index'
import { Route as SiteWishlistRouteImport } from './routes/_site.wishlist'
import { Route as SiteShopsRouteImport } from './routes/_site.shops'
import { Route as SiteLegalRouteImport } from './routes/_site.legal'
import { Route as SiteGiftCardsRouteImport } from './routes/_site.gift-cards'
import { Route as SiteGenresRouteImport } from './routes/_site.genres'
import { Route as SiteGamesRouteImport } from './routes/_site.games'
import { Route as SiteDealsRouteImport } from './routes/_site.deals'
import { Route as SiteAccountIndexRouteImport } from './routes/_site.account.index'
import { Route as SiteGameSlugRouteImport } from './routes/_site.game.$slug'
import { Route as SiteAccountRegisterRouteImport } from './routes/_site.account.register'
import { Route as SiteAccountPriceAlertsRouteImport } from './routes/_site.account.price-alerts'
import { Route as SiteAccountLoginRouteImport } from './routes/_site.account.login'
import { Route as SiteLegalSteamRouteImport } from './routes/_site.legal.steam'
import { Route as SiteLegalImpressumRouteImport } from './routes/_site.legal.impressum'
import { Route as SiteLegalDatenschutzRouteImport } from './routes/_site.legal.datenschutz'
import { Route as SiteLegalAgbRouteImport } from './routes/_site.legal.agb'
import { Route as SiteLegalAffiliateRouteImport } from './routes/_site.legal.affiliate'
import { Route as SiteGiftCardsIndexRouteImport } from './routes/_site.gift-cards.index'
import { Route as SiteGiftCardsBrandRouteImport } from './routes/_site.gift-cards.$brand'
import { Route as SiteGiftCardsBrandIndexRouteImport } from './routes/_site.gift-cards.$brand.index'
import { Route as SiteGiftCardsBrandIdRouteImport } from './routes/_site.gift-cards.$brand.$id'

const LogoutRoute = LogoutRouteImport.update({
            id: '/logout',path: '/logout',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const Keys4steamPreviewRoute = Keys4steamPreviewRouteImport.update({
            id: '/keys4steam-preview',path: '/keys4steam-preview',getParentRoute: () => rootRouteImport
          })
const AdminRoute = AdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => rootRouteImport
          })
const SiteRoute = SiteRouteImport.update({
            id: '/_site',getParentRoute: () => rootRouteImport
          })
const AdminIndexRoute = AdminIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AdminRoute
          })
const AdminShopsRoute = AdminShopsRouteImport.update({
            id: '/shops',path: '/shops',getParentRoute: () => AdminRoute
          })
const AdminOffersRoute = AdminOffersRouteImport.update({
            id: '/offers',path: '/offers',getParentRoute: () => AdminRoute
          })
const AdminLoginRoute = AdminLoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => AdminRoute
          })
const AdminImportRoute = AdminImportRouteImport.update({
            id: '/import',path: '/import',getParentRoute: () => AdminRoute
          })
const AdminGiftCardsRoute = AdminGiftCardsRouteImport.update({
            id: '/gift-cards',path: '/gift-cards',getParentRoute: () => AdminRoute
          })
const AdminGamivoRoute = AdminGamivoRouteImport.update({
            id: '/gamivo',path: '/gamivo',getParentRoute: () => AdminRoute
          })
const AdminGamingDragonsRoute = AdminGamingDragonsRouteImport.update({
            id: '/gaming-dragons',path: '/gaming-dragons',getParentRoute: () => AdminRoute
          })
const AdminGamesplanetRoute = AdminGamesplanetRouteImport.update({
            id: '/gamesplanet',path: '/gamesplanet',getParentRoute: () => AdminRoute
          })
const AdminGamesRoute = AdminGamesRouteImport.update({
            id: '/games',path: '/games',getParentRoute: () => AdminRoute
          })
const AdminGamersgateRoute = AdminGamersgateRouteImport.update({
            id: '/gamersgate',path: '/gamersgate',getParentRoute: () => AdminRoute
          })
const AdminGameboostRoute = AdminGameboostRouteImport.update({
            id: '/gameboost',path: '/gameboost',getParentRoute: () => AdminRoute
          })
const AdminGamebilletRoute = AdminGamebilletRouteImport.update({
            id: '/gamebillet',path: '/gamebillet',getParentRoute: () => AdminRoute
          })
const AdminEnebaRoute = AdminEnebaRouteImport.update({
            id: '/eneba',path: '/eneba',getParentRoute: () => AdminRoute
          })
const AdminElectronicFirstRoute = AdminElectronicFirstRouteImport.update({
            id: '/electronic-first',path: '/electronic-first',getParentRoute: () => AdminRoute
          })
const AdminCjsCdkeysRoute = AdminCjsCdkeysRouteImport.update({
            id: '/cjs-cdkeys',path: '/cjs-cdkeys',getParentRoute: () => AdminRoute
          })
const SiteIndexRoute = SiteIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => SiteRoute
          })
const SiteWishlistRoute = SiteWishlistRouteImport.update({
            id: '/wishlist',path: '/wishlist',getParentRoute: () => SiteRoute
          })
const SiteShopsRoute = SiteShopsRouteImport.update({
            id: '/shops',path: '/shops',getParentRoute: () => SiteRoute
          })
const SiteLegalRoute = SiteLegalRouteImport.update({
            id: '/legal',path: '/legal',getParentRoute: () => SiteRoute
          })
const SiteGiftCardsRoute = SiteGiftCardsRouteImport.update({
            id: '/gift-cards',path: '/gift-cards',getParentRoute: () => SiteRoute
          })
const SiteGenresRoute = SiteGenresRouteImport.update({
            id: '/genres',path: '/genres',getParentRoute: () => SiteRoute
          })
const SiteGamesRoute = SiteGamesRouteImport.update({
            id: '/games',path: '/games',getParentRoute: () => SiteRoute
          })
const SiteDealsRoute = SiteDealsRouteImport.update({
            id: '/deals',path: '/deals',getParentRoute: () => SiteRoute
          })
const SiteAccountIndexRoute = SiteAccountIndexRouteImport.update({
            id: '/account/',path: '/account/',getParentRoute: () => SiteRoute
          })
const SiteGameSlugRoute = SiteGameSlugRouteImport.update({
            id: '/game/$slug',path: '/game/$slug',getParentRoute: () => SiteRoute
          })
const SiteAccountRegisterRoute = SiteAccountRegisterRouteImport.update({
            id: '/account/register',path: '/account/register',getParentRoute: () => SiteRoute
          })
const SiteAccountPriceAlertsRoute = SiteAccountPriceAlertsRouteImport.update({
            id: '/account/price-alerts',path: '/account/price-alerts',getParentRoute: () => SiteRoute
          })
const SiteAccountLoginRoute = SiteAccountLoginRouteImport.update({
            id: '/account/login',path: '/account/login',getParentRoute: () => SiteRoute
          })
const SiteLegalSteamRoute = SiteLegalSteamRouteImport.update({
            id: '/steam',path: '/steam',getParentRoute: () => SiteLegalRoute
          })
const SiteLegalImpressumRoute = SiteLegalImpressumRouteImport.update({
            id: '/impressum',path: '/impressum',getParentRoute: () => SiteLegalRoute
          })
const SiteLegalDatenschutzRoute = SiteLegalDatenschutzRouteImport.update({
            id: '/datenschutz',path: '/datenschutz',getParentRoute: () => SiteLegalRoute
          })
const SiteLegalAgbRoute = SiteLegalAgbRouteImport.update({
            id: '/agb',path: '/agb',getParentRoute: () => SiteLegalRoute
          })
const SiteLegalAffiliateRoute = SiteLegalAffiliateRouteImport.update({
            id: '/affiliate',path: '/affiliate',getParentRoute: () => SiteLegalRoute
          })
const SiteGiftCardsIndexRoute = SiteGiftCardsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => SiteGiftCardsRoute
          })
const SiteGiftCardsBrandRoute = SiteGiftCardsBrandRouteImport.update({
            id: '/$brand',path: '/$brand',getParentRoute: () => SiteGiftCardsRoute
          })
const SiteGiftCardsBrandIndexRoute = SiteGiftCardsBrandIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => SiteGiftCardsBrandRoute
          })
const SiteGiftCardsBrandIdRoute = SiteGiftCardsBrandIdRouteImport.update({
            id: '/$id',path: '/$id',getParentRoute: () => SiteGiftCardsBrandRoute
          })





const SiteGiftCardsBrandRouteChildren = {
  SiteGiftCardsBrandIdRoute: SiteGiftCardsBrandIdRoute,SiteGiftCardsBrandIndexRoute: SiteGiftCardsBrandIndexRoute
}

const SiteGiftCardsBrandRouteWithChildren = SiteGiftCardsBrandRoute._addFileChildren(SiteGiftCardsBrandRouteChildren)



const SiteGiftCardsRouteChildren = {
  SiteGiftCardsBrandRoute: SiteGiftCardsBrandRouteWithChildren,SiteGiftCardsIndexRoute: SiteGiftCardsIndexRoute
}

const SiteGiftCardsRouteWithChildren = SiteGiftCardsRoute._addFileChildren(SiteGiftCardsRouteChildren)




const SiteLegalRouteChildren = {
  SiteLegalAffiliateRoute: SiteLegalAffiliateRoute,SiteLegalAgbRoute: SiteLegalAgbRoute,SiteLegalDatenschutzRoute: SiteLegalDatenschutzRoute,SiteLegalImpressumRoute: SiteLegalImpressumRoute,SiteLegalSteamRoute: SiteLegalSteamRoute
}

const SiteLegalRouteWithChildren = SiteLegalRoute._addFileChildren(SiteLegalRouteChildren)



const SiteRouteChildren = {
  SiteDealsRoute: SiteDealsRoute,SiteGamesRoute: SiteGamesRoute,SiteGenresRoute: SiteGenresRoute,SiteGiftCardsRoute: SiteGiftCardsRouteWithChildren,SiteLegalRoute: SiteLegalRouteWithChildren,SiteShopsRoute: SiteShopsRoute,SiteWishlistRoute: SiteWishlistRoute,SiteIndexRoute: SiteIndexRoute,SiteAccountLoginRoute: SiteAccountLoginRoute,SiteAccountPriceAlertsRoute: SiteAccountPriceAlertsRoute,SiteAccountRegisterRoute: SiteAccountRegisterRoute,SiteGameSlugRoute: SiteGameSlugRoute,SiteAccountIndexRoute: SiteAccountIndexRoute
}

const SiteRouteWithChildren = SiteRoute._addFileChildren(SiteRouteChildren)




const AdminRouteChildren = {
  AdminCjsCdkeysRoute: AdminCjsCdkeysRoute,AdminElectronicFirstRoute: AdminElectronicFirstRoute,AdminEnebaRoute: AdminEnebaRoute,AdminGamebilletRoute: AdminGamebilletRoute,AdminGameboostRoute: AdminGameboostRoute,AdminGamersgateRoute: AdminGamersgateRoute,AdminGamesRoute: AdminGamesRoute,AdminGamesplanetRoute: AdminGamesplanetRoute,AdminGamingDragonsRoute: AdminGamingDragonsRoute,AdminGamivoRoute: AdminGamivoRoute,AdminGiftCardsRoute: AdminGiftCardsRoute,AdminImportRoute: AdminImportRoute,AdminLoginRoute: AdminLoginRoute,AdminOffersRoute: AdminOffersRoute,AdminShopsRoute: AdminShopsRoute,AdminIndexRoute: AdminIndexRoute
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

const rootRouteChildren = {
  SiteRoute: SiteRouteWithChildren,AdminRoute: AdminRouteWithChildren,Keys4steamPreviewRoute: Keys4steamPreviewRoute,LoginRoute: LoginRoute,LogoutRoute: LogoutRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)